/**
 * Jupiter Plugin v1 — keep in sync with https://plugin.jup.ag/plugin-v1.js
 *
 * Regenerate SRI after upstream updates:
 *   curl -sL https://plugin.jup.ag/plugin-v1.js | openssl dgst -sha384 -binary | openssl base64 -A
 */
export const JUPITER_PLUGIN_SCRIPT_SRC = "https://plugin.jup.ag/plugin-v1.js";

/** sha384 integrity for JUPITER_PLUGIN_SCRIPT_SRC (fetched 2026-07-08). */
export const JUPITER_PLUGIN_SCRIPT_INTEGRITY =
  "sha384-YpP70VtLBe2731COyOpvXZ7Giyn0aRiUz2BJ+9mqmlqMF45aTFSUIiAbSebFH2YU";
